import { http } from '../../config/axios'

 const findSaldoClienteCompraService = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/cliente-saldo-compra/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findSaldoClienteCompraService', error)
      throw Error(error.response.data)
    })
}

export default findSaldoClienteCompraService;
